import { useMutation } from '@apollo/client'

import { MUTATION_UPDATE_PROJECT_FILE } from '@libs/apollo/mutations'

import { LocalFile, ProjectFileUpdateInput, ProjectFile, MutationUpdateProjectFileArgs } from '@types'

import { useCreateFile } from '@hooks/file/create-file.hook'

interface Data {
  updateProjectFile?: ProjectFile
}

export const useUpdateProjectFile = (): {
  updateProjectFile: (
    input: Omit<ProjectFileUpdateInput, 'fileId'>,
    file?: LocalFile,
  ) => Promise<ProjectFile | undefined>
} => {
  const { createFile } = useCreateFile()

  const [updateProjectFile] = useMutation<Data, MutationUpdateProjectFileArgs>(MUTATION_UPDATE_PROJECT_FILE, {
    notifyOnNetworkStatusChange: true,
  })

  const _updateProjectFile = async (
    input: Omit<ProjectFileUpdateInput, 'fileId'>,
    file?: LocalFile,
  ): Promise<ProjectFile | undefined> => {
    try {
      let remoteFile: Awaited<ReturnType<typeof createFile>>
      if (file) {
        remoteFile = await createFile(file)
      }

      const result = await updateProjectFile({
        variables: {
          input: {
            projectFileId: input.projectFileId,
            name: input.name,
            description: input.description,
            fileId: remoteFile?.id,
            folderId: input.folderId,
          },
        },
      })

      return result.data?.updateProjectFile
    } catch (error) {
      console.error(error)
    }
  }

  return { updateProjectFile: _updateProjectFile }
}
